type LogContext<T> = Record<string, unknown | T> & {
  message?: string;
  activity?: string;
  error?: T;
};

type ApplicationLogContextKeys = 'advertiserId' | 'userId';
type ApplicationLogContext = Record<ApplicationLogContextKeys, unknown>;

interface Logger {
  error: <T>(message: string, context?: LogContext<T>) => void;
  configureApplicationContext: (
    context: Partial<ApplicationLogContext>,
  ) => void;
}

let logger: Logger;

const getLogger = (): Logger => {
  logger ??= createDefaultLogger();
  return logger;
};

const createDefaultLogger = (): Logger => ({
  error: console.error,
  configureApplicationContext: () => {},
});

const setLogger = (loggerToUse: Logger) => {
  logger = loggerToUse;
};

export { getLogger, setLogger, type Logger, type ApplicationLogContext };
